import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Text } from 'recharts';
// import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import { Modal } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ShopOpenPopupSuccess from './ShopOpenPopupSuccess';
import CloseButon from '../../components/atoms/CloseButton';
import ShopOpenButton from '../../components/atoms/ShopOpenButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import {
  getGroupIdentities,
  editIdentityGroupStatus
} from '../../actions/Identity';
import { releaseShop } from '../../actions/Shop';
import { sendLogin } from '../../auth/Auth';

const styles = {
  root: {
    position: 'absolute',
    width: '95%',
    maxWidth: '355px',
    height: 'auto',
    maxHeight: '90%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    backgroundColor: '#fff',
    padding: 15,
    overflow: 'auto',
    outline: 'none',
    fontSize: 12,
    lineHeight: '16px',
    color: '#333333',
    borderRadius: 4
  },
  document: {
    width: '90%',
    margin: '5px'
  },
  itemDiv: {
    margin: '20px auto',
    textLink: {
      padding: 10
    }
  },
  textIntro: {
    lineHeight: '24px',
    fontWeight: 500,
    fontSize: 12
  },
  textNum: {
    fontSize: 14,
    lineHeight: '19px',
    color: '#000',
    fontWeight: 'bold'
  },
  textCheckbox: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 500
  },
  textLink: {
    marginLeft: '32px'
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold',
    left: '-8px'
  },
  flexStart: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  inlineBlock: {
    display: 'inline-block'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getGroupIdentities, editIdentityGroupStatus, releaseShop },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('resultMessage', 'setResultMessage', ''),
  withState('openShopSuccess', 'setOpenShopSuccess', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isChangeSuccess', 'updateIsChangeSuccess', false),
  withState('document', 'setDocument', ''),
  withState('disabled', 'setDisabled', true),
  withState('agreeOne', 'setAgreeOne', false),
  withState('agreeTwo', 'setAgreeTwo', false),
  withState('agreeThree', 'setAgreeThree', false),
  withState('agreeFour', 'setAgreeFour', false),
  withState('agreeFive', 'setAgreeFive', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    account,
    loading,
    isChangeSuccess,
    updateIsChangeSuccess,
    updateLoading,
    openProgress,
    updateOpenProgress,
    setOpenShopOpen,
    openShopSuccess,
    setOpenShopSuccess,
    resultMessage,
    setResultMessage,
    agreeOne,
    agreeTwo,
    agreeThree,
    setAgreeOne,
    setAgreeTwo,
    setAgreeThree,
    agreeFour,
    setAgreeFour,
    agreeFive,
    setAgreeFive,
    updateDisabled
  }) => {
    const openShopAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const result = await actions
        .releaseShop(account.shopId)
        .then(data => checkSession(data));
      if (result.type === 'RELEASE_SHOP_SUCCESS') {
        updateIsChangeSuccess(true);
        updateLoading(false);
        setOpenShopSuccess(true);
        updateDisabled(true);
      } else {
        updateIsChangeSuccess(false);
        setResultMessage('開店に失敗しました。');
        updateLoading(false);
      }
    };
    const closeAction = () => {
      setOpenShopOpen(false);
      setOpenShopSuccess(false);
    };

    const progressOkAction = () => {
      if (isChangeSuccess) {
        updateOpenProgress(false);
      } else {
        updateOpenProgress(false);
      }
    };

    return (
      <div className={classes.root}>
        <Typography className={classes.textIntro}>
          下記の確認事項をお読みの上、チェックしてください。
          <br />
          すべてチェックしたら「開店する」ボタンが押せるようになります。
          <br />
          <br />
        </Typography>
        <div className={classes.itemDiv}>
          <Text className={classes.textNum}>①管理画面を確認した</Text>
          <FormControlLabel
            control={<Checkbox color="primary" checked={agreeOne} />}
            label={
              <Typography className={classes.textCheckbox}>
                ログインできることを確かめましたか？
              </Typography>
            }
            onChange={e => {
              setAgreeOne(e.target.checked);
            }}
          />
        </div>
        <div className={classes.itemDiv}>
          <Text className={classes.textNum}>②売上の入金について確認した</Text>
          <FormControlLabel
            className={classes.flexStart}
            control={<Checkbox color="primary" checked={agreeTwo} />}
            label={
              <Typography className={classes.textCheckbox}>
                当月末締め、翌月末支払いとなり、振込手数料が必要です。なお、参画いただくキャンペーン等によって振込手数料や入金日が異なる場合がございますので、別途ご確認ください。
              </Typography>
            }
            onChange={e => {
              setAgreeTwo(e.target.checked);
            }}
          />
        </div>
        <div className={classes.itemDiv}>
          <Text className={classes.textNum}>③店内オペレーションを確認した</Text>
          <FormControlLabel
            control={<Checkbox color="primary" checked={agreeThree} />}
            label={
              <Typography className={classes.textCheckbox}>
                オペレーション解説記事
              </Typography>
            }
            onChange={e => {
              setAgreeThree(e.target.checked);
            }}
          />
          <div>
            <Link
              href="https://support.gochimeshi.com/s/article/GOCHI%E3%83%97%E3%83%A9%E3%83%83%E3%83%88%E3%83%95%E3%82%A9%E3%83%BC%E3%83%A0%E5%88%A9%E7%94%A8%E6%99%82%E3%81%AE%E5%BA%97%E9%A0%AD%E3%82%AA%E3%83%9A%E3%83%AC%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3%E5%9F%BA%E6%9C%AC%E5%AF%BE%E5%BF%9C%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB"
              target="_blank"
              rel="noreferrer"
              className={[classes.textLink, classes.inlineBlock]}
            >
              GOCHIプラットフォーム利用時の店頭オペレーション 基本対応マニュアル
            </Link>
          </div>
        </div>
        <div className={classes.itemDiv}>
          <Text className={classes.textNum}>④ご対応サービスの確認</Text>
          <FormControlLabel
            className={classes.flexStart}
            control={<Checkbox color="primary" checked={agreeFour} />}
            label={
              <Typography className={classes.textCheckbox}>
                ご登録いただいた店舗は、GOCHIプラットフォームが提供するすべてのサービスに対応する事を確認しました。
                <br />
                （ごちめし／社食ごちめし／こどもごちめし(※)／GFB／その他キャンペーンなど）
                <br />
                ※こどもごちめしは、原則飲食店のみ
              </Typography>
            }
            onChange={e => {
              setAgreeFour(e.target.checked);
            }}
          />
        </div>
        <div className={classes.itemDiv}>
          <Text className={classes.textNum}>
            ⑤ＧＯＣＨＩプラットフォームの各種サービス・規約の確認
          </Text>
          <FormControlLabel
            className={classes.flexStart}
            control={<Checkbox color="primary" checked={agreeFive} />}
            label={
              <Typography className={classes.textCheckbox}>
                GOCHIプラットフォームの各種サービス・規約を確認しました。
              </Typography>
            }
            onChange={e => {
              setAgreeFive(e.target.checked);
            }}
          />
          <div>
            <Link
              href="https://gochimeshi.com/policy/"
              target="_blank"
              rel="noreferrer"
              className={classes.textLink}
            >
              https://gochimeshi.com/policy/
            </Link>
          </div>
        </div>
        <ShopOpenButton
          onClickAction={openShopAction}
          disabled={
            !(agreeOne && agreeTwo && agreeThree && agreeFour && agreeFive)
          }
        />
        <div>
          <CloseButon
            className={classes.btnClose}
            onClickAction={closeAction}
          />
        </div>
        <div>
          <Modal open={openShopSuccess}>
            <ShopOpenPopupSuccess
              setOpenShopSuccess={setOpenShopSuccess}
              setOpenShopOpen={setOpenShopOpen}
            />
          </Modal>
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
